<template>
  <div class="container order">
    <div class="left">
      <div class="block show-desktop">
        <h1 class="heading">{{ $t('OrderOverview.your_composition') }}</h1>
        <div
          v-if="settings.step_3_description"
          v-html="settings.step_3_description"
        ></div>
        <p v-else>
          {{ $t('BrandColor.start_selecting') }}
        </p>
      </div>
      <div class="image">
        <img :src="line.image" alt="line_image" />
      </div>
      <div class="action">
        <label>
          <strong>{{ $t('OrderOverview.background_style') }}</strong>
        </label>

        <div class="input-holder">
          <InputSelectBox
            :options="backgroundOptions"
            :id="bodyBackgroundId"
            @change="updateBackground"
          />

          <div
            v-if="bodyBackground && bodyBackground.type === 'custom'"
            class="custom-background-image-uploader"
          >
            <label for="custom-background-image">
              <strong>{{ $t('OrderOverview.custom_background') }}</strong>
            </label>
            <input
              id="custom-background-image"
              type="file"
              accept="image/*"
              @input="updateCustomBackgroundImage"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="right">
      <OrderSummary />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import OrderSummary from '../order/OrderSummary';
import InputSelectBox from '../utilities/InputSelectBox';

export default {
  name: 'StepFinishOrder',
  components: {
    OrderSummary,
    InputSelectBox,
  },
  computed: {
    ...mapGetters({
      backgroundOptions: 'data/getBackgroundOptions',
      bodyBackground: 'getBodyBackground',
      line: 'build/getSelectedLine',
    }),
    ...mapState('data', ['settings']),

    bodyBackgroundId() {
      for (const bg of this.backgroundOptions) {
        if (bg.value === this.bodyBackground) return bg.id;
      }

      return undefined;
    },
  },
  methods: {
    updateBackground(value) {
      this.$store.commit('setBodyBackground', value);
    },
    updateCustomBackgroundImage(event) {
      const file = event.target.files[0];

      if (!file) {
        return;
      }

      const customBackgroundOption = this.backgroundOptions.find(
        (option) => option.value.type === 'custom'
      );
      customBackgroundOption.value.image = URL.createObjectURL(file);

      this.$store.commit('setBodyBackground', customBackgroundOption.value);
    },
  },
  mounted() {
    this.$store.commit('setBodyBackground', this.backgroundOptions[0].value);
  },
  destroyed() {
    this.$store.commit('setBodyBackground', undefined);
  },
};
</script>
